module.exports = __webpack_public_path__ + "img/chinesecompany191.5419e477.png";